import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { simpleCreateNotification } from 'hooks/notificationHandler'
import { useCreateRfiResponseDisciplineMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  RFIResponseDiscipline,
  useResponseDisciplinesTableContext,
} from '../../../../ResponseDisciplinesTableContext'
import {
  CreateResponseDisciplineModalBody,
  CreateResponseDisciplineModalBodyValues,
} from './components/CreateResponseDisciplineModalBody'
import { useProjectContext } from 'context/ProjectContext'

export function useCreateOptions(): CreateHeaderActionOptions<RFIResponseDiscipline> {
  const { projectId } = useProjectContext()
  const { refetch, fetching } = useResponseDisciplinesTableContext()
  const [createResponseDiscipline] = useCreateRfiResponseDisciplineMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      createRFIResponseDiscipline: {
        responseDiscipline: { name },
      },
    }) => simpleCreateNotification(name),
  })
  return {
    loading: fetching,
    entity: 'Response Discipline',
    permission: Permission.CreateRFIResponseDiscipline,
    modal: {
      type: 'simple',
      body: <CreateResponseDisciplineModalBody />,
      onOk: async ({
        name,
        description,
        responders,
      }: CreateResponseDisciplineModalBodyValues) => {
        await createResponseDiscipline({
          variables: {
            createRfiResponseDisciplineInput: {
              projectId,
              name,
              description,
              userIds: responders?.map(({ value }) => value.toString()),
            },
          },
        })
        await refetch()
      },
    },
  }
}
